enum TYPE_COURRIER {
  RAPPORT_POST_ROP = "Rapport post ROP",
  COURRIER_ROI = "Courrier ROI",
  COURRIER_VISITE_RECEPTION = "Courrier visite réception",
  CANEVAS_ROP = "Canevas de ROP",
}

export default TYPE_COURRIER;
